/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r5'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r5'">R5</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Host route on R5 + default route on R1 via R3</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R5</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R5Items" :key="'t1r5-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r5Completion[item.key])"></div>
                  <code class="text-base" :class="r5Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R1Items" :key="'t1r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R5</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in verifyTask1Items" :key="'v1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r5Completion[item.key])"></div>
                  <code class="text-base" :class="r5Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Floating route on R1 (AD 225) + R2 return + failover verify</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R1Items" :key="'t2r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R2Items" :key="'t2r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R5</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in verifyTask2Items" :key="'v2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r5Completion[item.key])"></div>
                  <code class="text-base" :class="r5Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rk in ['r1','r2','r5']" :key="'s-'+rk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(rk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(rk).saved)"></div>
                    <code class="text-base" :class="getComp(rk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r5'" key="r5" id="r5_terminal" :commands="r5Commands" :prompt="r5Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R5" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "end" to reach exec mode for ping and traceroute.';

const mkCommands = (rk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(rk),
  configure:  (x) => vm.iosConfigure(rk, x),
  conf:       (x) => vm.iosConfigure(rk, x),
  interface:  (x) => vm.iosInterface(rk, x),
  int:        (x) => vm.iosInterface(rk, x),
  ip:         (x) => vm.iosIp(rk, x),
  shut:       () => vm.iosShutdown(rk),
  shutdown:   () => vm.iosShutdown(rk),
  ping:       (x) => vm.iosPing(rk, x),
  traceroute: (x) => vm.iosTraceroute(rk, x),
  exit:       () => vm.iosExit(rk),
  end:        () => vm.iosEnd(rk),
  copy:       (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_Routing_Configuration_Sim_5.png',
      sel: 'r1',
      totalScore: 0,

      r1: { mode: 'exec', currentIf: null },
      r2: { mode: 'exec', currentIf: null },
      r5: { mode: 'exec', currentIf: null },

      // r1(5) + r2(2) + r5(6) = 13 total keys
      r1Completion: { defaultRoute1: false, floatingRoute: false, e01If: false, e01Shut: false, saved: false },
      r2Completion: { returnRoute: false, saved: false },
      r5Completion: { hostRoute: false, pingTask1: false, tracerouteTask1: false, pingTask2: false, tracerouteTask2: false, saved: false },

      r1Commands: null, r2Commands: null, r5Commands: null,

      task1R5Items:     [{ key: 'hostRoute',   label: 'ip route 10.200.220.6 255.255.255.255 10.100.110.1' }],
      task1R1Items:     [{ key: 'defaultRoute1', label: 'ip route 0.0.0.0 0.0.0.0 10.133.13.3' }],
      verifyTask1Items: [{ key: 'pingTask1', label: 'ping 10.200.220.6' }, { key: 'tracerouteTask1', label: 'traceroute 10.200.220.6' }],
      task2R1Items: [
        { key: 'floatingRoute', label: 'ip route 0.0.0.0 0.0.0.0 10.122.12.2 225' },
        { key: 'e01If',         label: 'interface e0/1' },
        { key: 'e01Shut',       label: 'shut' },
      ],
      task2R2Items:     [{ key: 'returnRoute', label: 'ip route 10.100.110.0 255.255.255.128 10.122.12.1' }],
      verifyTask2Items: [{ key: 'pingTask2', label: 'ping 10.200.220.6' }, { key: 'tracerouteTask2', label: 'traceroute 10.200.220.6' }],
    };
  },

  computed: {
    r1Prompt() { const m=this.r1.mode; return m==='config-if'?'R1(config-if)#':m==='config'?'R1(config)#':'R1#'; },
    r2Prompt() { const m=this.r2.mode; return m==='config-if'?'R2(config-if)#':m==='config'?'R2(config)#':'R2#'; },
    r5Prompt() { const m=this.r5.mode; return m==='config-if'?'R5(config-if)#':m==='config'?'R5(config)#':'R5#'; },

    task1Progress() {
      return [this.r5Completion.hostRoute, this.r1Completion.defaultRoute1,
              this.r5Completion.pingTask1, this.r5Completion.tracerouteTask1].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 4; },

    task2Progress() {
      return [this.r1Completion.floatingRoute, this.r1Completion.e01If, this.r1Completion.e01Shut,
              this.r2Completion.returnRoute,
              this.r5Completion.pingTask2, this.r5Completion.tracerouteTask2].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 6; },

    saveProgress() {
      return [this.r1Completion.saved, this.r2Completion.saved, this.r5Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress === 3; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
    this.r5Commands = mkCommands('r5', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    devLabel(k) { return { r1:'R1', r2:'R2', r5:'R5' }[k] || k.toUpperCase(); },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r5Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 13) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosConfigure(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (s.mode === 'config-if') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; this[rk].currentIf = null; return createStdout(''); },

    iosInterface(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config' && s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in configuration mode');
      let _ifRaw = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _ifRaw = _ifRaw + x._[2];
      const ifNorm = this.normalizeIf(_ifRaw);
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[rk + 'Completion'];
      if (rk === 'r1' && ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk];
      if ((x._[1] || '').toLowerCase() !== 'route') return createStderr('% Invalid input detected');
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const dest    = String(x._[2] || '');
      const mask    = String(x._[3] || '');
      const nextHop = String(x._[4] || '');
      const ad      = String(x._[5] || '');
      const c       = this[rk + 'Completion'];

      // R5: host route to 10.200.220.6 /32
      if (rk === 'r5' && dest === '10.200.220.6' && mask === '255.255.255.255' && nextHop === '10.100.110.1' && !c.hostRoute) {
        c.hostRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Host route configured on R5 for 10.200.220.6 via next-hop 10.100.110.1 (R1 e0/2). ' +
          'A host route uses a /32 mask — it matches exactly one IP address, giving the most specific route possible. ' +
          'Specific routes always win over less-specific routes in the routing table. ' +
          '→ Configure the default static route on R1: "ip route 0.0.0.0 0.0.0.0 10.133.13.3".'
        ));
      }

      // R1: default route via R3 (task 1, no AD = default 1)
      if (rk === 'r1' && dest === '0.0.0.0' && mask === '0.0.0.0' && nextHop === '10.133.13.3' && !c.defaultRoute1) {
        c.defaultRoute1 = true; this.updateScore();
        return createStdout(this.guide(
          'Default static route configured on R1 via 10.133.13.3 (R3). ' +
          'A default route (0.0.0.0/0) matches all destinations with no more specific entry — it\'s the gateway of last resort. ' +
          'Traffic from R5 (next-hop R1) will be forwarded to R3, then onward to R4 and R6. ' +
          '→ Switch to R5: type "end" then "ping 10.200.220.6" and "traceroute 10.200.220.6" to verify.'
        ));
      }

      // R1: floating default route via R2 (task 2, AD 225)
      if (rk === 'r1' && dest === '0.0.0.0' && mask === '0.0.0.0' && nextHop === '10.122.12.2' && ad === '225' && !c.floatingRoute) {
        c.floatingRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Floating static default route configured on R1 via 10.122.12.2 (R2) with AD 225. ' +
          'AD 225 > AD 1 (primary route) — this route is NOT installed in the routing table while the R3 link is up. ' +
          'It "floats" in config, invisible to the forwarding engine. If R1\'s link to R3 fails, this route activates automatically with zero manual intervention. ' +
          '→ Configure R2\'s return route: "ip route 10.100.110.0 255.255.255.128 10.122.12.1".'
        ));
      }

      // R2: return traffic route
      if (rk === 'r2' && dest === '10.100.110.0' && mask === '255.255.255.128' && nextHop === '10.122.12.1' && !c.returnRoute) {
        c.returnRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Return traffic route configured on R2. Without this route R2 would not know how to reach R5\'s subnet (10.100.110.0/25) — return packets would be dropped silently. ' +
          '→ Now shut down R1 e0/1 to simulate the R3 link failure: on R1, type "interface e0/1" then "shut".'
        ));
      }

      return createStdout('');
    },

    iosShutdown(rk) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c = this[rk + 'Completion'];
      if (rk === 'r1' && s.currentIf === '0/1' && !c.e01Shut) {
        c.e01Shut = true; this.updateScore();
        return createStdout(
          '%LINEPROTO-5-UPDOWN: Line protocol on Interface GigabitEthernet0/1, changed state to down' +
          this.guide(
            'R1 e0/1 (link to R3) is now administratively down. The primary default route via R3 (AD 1) is withdrawn from R1\'s routing table. ' +
            'The floating static route via R2 (AD 225) now becomes the best available route and activates automatically. ' +
            '→ Switch to R5: "end" then "ping 10.200.220.6" and "traceroute 10.200.220.6" to confirm failover to R2 path.'
          )
        );
      }
      return createStdout('');
    },

    iosPing(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      const target = (x._[1] || '').toLowerCase();
      const c5 = this.r5Completion, c1 = this.r1Completion, c2 = this.r2Completion;

      if (target === '10.200.220.6') {
        const via2 = c1.e01Shut && c1.floatingRoute && c2.returnRoute;
        const via3 = c5.hostRoute && c1.defaultRoute1;

        if (via2) {
          const out = 'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 10.200.220.6, timeout is 2 seconds:<br>!!!!!</b><br>Success rate is 100 percent (5/5), round-trip min/avg/max = 1/2/4 ms';
          if (rk === 'r5' && !c5.pingTask2) { c5.pingTask2 = true; this.updateScore(); }
          return createStdout(out + this.guide(
            'Ping to R6 successful via R2 failover path (!!!!!). 100% — no ARP delay since R5\'s MAC table is already populated. ' +
            'Path: R5→R1→R2→R4→R6. → Run "traceroute 10.200.220.6" to confirm the exact hop sequence.'
          ));
        }
        if (via3) {
          const out = 'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 10.200.220.6, timeout is 2 seconds:<br>.!!!!</b><br>Success rate is 80 percent (4/5), round-trip min/avg/max = 1/2/4 ms';
          if (rk === 'r5' && !c5.pingTask1) { c5.pingTask1 = true; this.updateScore(); }
          return createStdout(out + this.guide(
            'Ping to R6 successful via primary path (.!!!!). The leading "." is ARP resolving R1\'s MAC; 4 "!" confirm replies. ' +
            'Path: R5→R1→R3→R4→R6. → Run "traceroute 10.200.220.6" to confirm the hop sequence.'
          ));
        }
        return createStdout(
          'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 10.200.220.6, timeout is 2 seconds:<br>.....<br>Success rate is 0 percent (0/5)' +
          this.guide('Ping failed — configure the host route on R5 and the default route on R1 first.')
        );
      }

      return createStdout('Type escape sequence to abort.<br>.....<br>Success rate is 0 percent (0/5)');
    },

    iosTraceroute(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      const target = (x._[1] || '').toLowerCase();
      const c5 = this.r5Completion, c1 = this.r1Completion, c2 = this.r2Completion;

      if (target === '10.200.220.6') {
        const hdr  = 'Type escape sequence to abort.<br>Tracing the route to 10.200.220.6<br>';
        const via2 = c1.e01Shut && c1.floatingRoute && c2.returnRoute;
        const via3 = c5.hostRoute && c1.defaultRoute1;

        if (via2) {
          const out = hdr +
            '&nbsp;1&nbsp;&nbsp;10.100.110.1&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R1)<br>' +
            '&nbsp;2&nbsp;&nbsp;10.122.12.2&nbsp;&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R2)<br>' +
            '&nbsp;3&nbsp;&nbsp;10.240.24.4&nbsp;&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R4)<br>' +
            '&nbsp;4&nbsp;&nbsp;10.200.220.6&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R6)';
          if (rk === 'r5' && !c5.tracerouteTask2) { c5.tracerouteTask2 = true; this.updateScore(); }
          return createStdout(out + this.guide(
            'Failover confirmed: R5→R1→R2→R4→R6. The floating static route (AD 225) activated automatically when R1\'s link to R3 went down. ' +
            '→ Save all routers: "end" then "copy running-config startup-config".'
          ));
        }
        if (via3) {
          const out = hdr +
            '&nbsp;1&nbsp;&nbsp;10.100.110.1&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R1)<br>' +
            '&nbsp;2&nbsp;&nbsp;10.133.13.3&nbsp;&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R3)<br>' +
            '&nbsp;3&nbsp;&nbsp;10.34.34.4&nbsp;&nbsp;&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R4)<br>' +
            '&nbsp;4&nbsp;&nbsp;10.200.220.6&nbsp;&nbsp;0 msec 0 msec 0 msec&nbsp;&nbsp;(R6)';
          if (rk === 'r5' && !c5.tracerouteTask1) { c5.tracerouteTask1 = true; this.updateScore(); }
          return createStdout(out + this.guide(
            'Path confirmed: R5→R1→R3→R4→R6. Static routes working correctly. ' +
            '→ Configure Task 2: floating route on R1, return route on R2, then shut R1 e0/1 to test failover.'
          ));
        }
        return createStdout(hdr + '&nbsp;1&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;* ' + this.guide('Traceroute incomplete — configure routes first.'));
      }

      return createStdout('% Invalid destination');
    },

    iosCopy(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.devLabel(rk)} configuration saved. ` + (this.saveDone ? '✓ All routers saved — simulation complete!' : '→ Save the remaining routers.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r5_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

